
export async function productGalleryInit() {
    const {Gallery} = await import('../../gallery');
    new Gallery({
        productGalleryId: '#productGallery',
        productGalleryImages: '.product-gallery-main',
        modalId: '#productGalleryModal',
        modalGalleryId: '#modalGallery',
        modalGalleryImages: '.product-gallery-magnifier img'
    });
}
